import { useTranslation } from 'react-i18next';
import female_rounded from '../assets/images/content/Female.jpg';
import scan_face from '../assets/images/icons/scan_face.svg';
import { StyledLink } from '../components/StyledLink';
import { StyledLinkBlueHoverDarkBlue } from './../components/StyledLink';
import { getVersionDeploying } from '../axios/Footer/FooterUrlApi';
import React, { useState, useEffect } from 'react'

const Female = () => {
   const currentYear = new Date().getFullYear();
   const { t } = useTranslation();
   const [version, setVersion] = useState("");
   const langId = Number(localStorage.getItem('i18nextLngId') || 1);
   const langPath = langId === 2 ? 'en' : 'vi';
   const websiteUrl = `https://biosense.mobile-id.vn/${langPath}`;

   const getVersion = async () => {
      try {
         const response = await getVersionDeploying();
         setVersion(response.data.version)
      } catch (error) {
         console.error('Error:', error);
      } finally {
      }
   };

   useEffect(() => {
      getVersion();
   }, []);


   return (
      <div className='order-2 lg:order-1'>
         <div className='hidden relative w-full lg:flex flex-col-reverse justify-center items-center h-[480px]'>
            <div className='absolute bg-gradient-blur backdrop-blur-[14px] top-0 left-[8%] p-4 rounded gap-1 flex flex-col w-[250px] animate-scale-up-delay scale-0'>
               <div className='flex justify-between mb-3'>
                  <h6 className='text-base font-bold'>Jane Doe</h6>
                  <p className='font-normal text-sm'>{t('not-login-page.employee')}</p>
               </div>
               <div className='flex justify-between'>
                  <h6 className='text-base font-bold text-tree-poppy'>{t('not-login-page.check-in')}</h6>
                  <p className='text-base font-bold'>07:55:41 AM</p>
               </div>
               <p className='text-xs font-semibold'>{t('not-login-page.date')}</p>
            </div>
            <img src={female_rounded} alt='' className='rounded-full max-w-[350px]' />
            <div className='absolute bg-gradient-blur backdrop-blur-[14px] bottom-0 right-[8%] p-4 rounded gap-1 flex flex-col w-[250px] animate-scale-up-delay scale-0'>
               <div className='flex justify-between mb-3'>
                  <p className='text-base font-bold'>Jane Doe</p>
                  <p className='font-normal text-sm'>{t('not-login-page.visitor')}</p>
               </div>
               <div className='flex justify-between'>
                  <p className='text-base font-bold text-tree-poppy'>{t('not-login-page.welcome')}</p>
                  <p className='text-base font-bold'>07:55:41 AM</p>
               </div>
               <p className='text-xs font-semibold'>{t('not-login-page.date')}</p>
            </div>
            <div className='absolute animate-scale-up-slow top-0 bottom-0 my-auto right-0 left-0 mx-auto w-[135px] h-40 '>
               <img src={scan_face} alt='' />
            </div>
         </div>
         <div className='container text-center lg:text-left xl:pl-44 2xl:pl-64 overflow-hidden py-12'>
            <p>
               {t('not-login-page.version')} {version}
            </p>
            <div className='my-4'>
               <div className='h-[2px] border-t-[1px] border-solid text-neutral-900 opacity-15 bg-[#171717] w-[250px] mx-auto lg:mx-0'></div>
            </div>
            <p>
               Website:{' '}
               <a
                  href={websiteUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:text-blue-800 cursor-pointer"
               >
                  https://biosense.mobile-id.vn/
               </a>
               {/* <StyledLinkBlueHoverDarkBlue href='https://facialsense.mobile-id.vn/' target='_blank'>
                  https://facialsense.mobile-id.vn/
               </StyledLinkBlueHoverDarkBlue> */}
            </p>
            <p className="pt-3">
               {t('not-login-page.if-you-have-any-question')}{' '}
               <a
                  href="mailto:info@mobile-id.vn"
                  style={{
                     textDecoration: 'none',
                     color: '#3B82F6',
                  }}
                  onMouseEnter={(e) => (e.target.style.color = '#151686')}
                  onMouseLeave={(e) => (e.target.style.color = '#3B82F6')}
               >
                  {t('not-login-page.contact-us')}
               </a>
            </p>
            <p className='pt-3'>
               {t('common.copyright', { year: currentYear })}
               <StyledLink href={`https://mobile-id.vn/${langPath}`} target='_blank' className='!text-[#3B82F6]'>
                  {" "} Mobile-ID
               </StyledLink>
            </p>

            <div className='flex gap-1'>
               <StyledLink href={`https://mobile-id.vn/${langPath}/setup`} target='_blank' className='!text-[#3B82F6]'>
                  <p>{t('not-login-page.terms-and-conditions')}</p></StyledLink>

               <p>|</p>
               <StyledLink href={`https://mobile-id.vn/${langPath}/privacy-policy`} target='_blank' className='!text-[#3B82F6]'><p>{t('not-login-page.privacy-policy')}</p></StyledLink>

            </div>

         </div>
      </div>
   );
};

export default Female;
